import { FC, useState } from 'react'
import { useForm } from 'react-hook-form'

import './styles.scss'
import { IMenu, IMenuFavorite, FormResponseStatus } from '../../../models'
import { Title, Text, Button, Checkbox, Icon, FormLabelError } from '../../UI'
import { menuService, authService } from '../../../services'

type MenuFavoritesFormProps = {
  className?: string,
  style?: any,
  menu: IMenu[],
  defaultChecked?: IMenuFavorite[] | null,
  onSubmitChange: (status: FormResponseStatus) => void
  onCancel?: (event: any) => void
}

const MenuFavoritesForm:FC<MenuFavoritesFormProps> = ({ className = '', style, menu, defaultChecked, onSubmitChange, onCancel }) => {
  const fieldName = 'favorites'
  const { register, handleSubmit, formState: { errors }, getValues, watch } = useForm()
  const [submited, setSubmited] = useState<boolean>(false)
  const favorites = watch(fieldName, '')
  let itemIndex = 0;

  const setFavorites = async (optionsSel: any) => {
    const resp = await menuService.postFavoritesByUserCurrent(optionsSel)

    if(resp && resp.status === 'Ok') {
      onSubmitChange('SUCCESS')
    } else {
      onSubmitChange('ERROR')
    }
    setSubmited(false)
  }

  const isDefaultChecked = (id: number) => (!!(defaultChecked ? defaultChecked.find(it => it.menu_id === id) : undefined))

  const onSubmit = (data: any) => {
    const user = authService.getUserCurrentInfoStorage()
    let optionsSel: any[] = []

    data.favorites.forEach((id: string) => {
      const optionSel = (id ? menu.find(it => it.id === Number(id)) : undefined)

      if(optionSel) {
        optionsSel.push({
          name: optionSel.name,
          menu_id: optionSel.id,
          patient_id: user.id
        })
      }
    })

    if(optionsSel && optionsSel.length) {
      setSubmited(true)
      setFavorites(optionsSel)
    }
  }

  return (
    <div className={`py-50 px-20 ${className}`} style={style}>
      <div className="text-center px-25 lg:px-0">
        <Title component="h4" size="18" color="primary" weight="bold" className="lg:fz-22">Editar favoritos</Title>
        <Text className="mt-15">Selecciona máximo <strong>3 categorías</strong> que deseas mostrar en la sección de favoritos</Text>
      </div>

      <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <div className="favorites-wrapper mt-40">
          <div className="row">
            {defaultChecked !== null && menu.map((it, i) => {
              const id = `${fieldName}${it.id}`

              if(!it.favoriteShow) return null

              itemIndex++;

              return (
                <div key={i} className={`col-12 lg:col-4 ${itemIndex > 1 ? 'mt-30' : ''} ${itemIndex < 4 ? 'lg:mt-0' : ''}`}>
                  <Checkbox
                    {...register(fieldName, {
                      validate: {
                        required: (value) => {
                          const options = getValues(fieldName)
                          if(options.length === 0) return 'Selecciona una opción.'
                          else if(options.length > 3) return 'Selecciona máximo tres opciones.'
                          return true
                        }
                      }
                    })}
                    id={id}
                    name={fieldName}
                    value={it.id}
                    defaultChecked={isDefaultChecked(it.id)}
                    disabled={favorites && favorites.length >= 3 && favorites.indexOf(String(it.id)) === -1}
                  />
                  <Text component="label" htmlFor={id} size="12" weight="semibold">
                    <Icon name={it.icon} className="align-middle ml-10 mr-5" />{it.name}
                  </Text>
                </div>
              )}
            )}
          </div>
          {errors.favorites && <FormLabelError className="mt-15 text-center">{errors.favorites?.message}</FormLabelError>}
        </div>

        <div className="text-center mt-50">
          <Button size="md" fullWidth className="favorites-btn1" onClick={onCancel}>CANCELAR</Button>
          <Button
            type="submit"
            color="primary"
            size="md"
            fullWidth
            disabled={submited}
            className="favorites-btn2 ml-10"
          >GUARDAR FAVORITOS</Button>
        </div>
      </form>
    </div>
  )
}

export { MenuFavoritesForm }